//dota稀有度
const rarityList = [{
		val: 1,
		text: '普通'
	},
	{
		val: 2,
		text: '罕见'
	},
	{
		val: 3,
		text: '稀有'
	},
	{
		val: 4,
		text: '神话'
	},
	{
		val: 5,
		text: '不朽'
	},
	{
		val: 6,
		text: '传说'
	},
	{
		val: 7,
		text: '至宝'
	},
	{
		val: 8,
		text: '远古'
	}
]
export default rarityList
